import React from "react";
import { Review, SwiperCarousel, SliceConfig } from "~components";
import { useBreakpoints } from "~hooks";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const Reviews = ({ reviews, heading, className, sliceConfig }) => {
  const breakpoints = useBreakpoints();
  const isBreakpoint = breakpoints.largeTablet;
  const slidesPerView = isBreakpoint ? 3 : 1;

  const mobileReviews = [];
  const REVIEWS_PER_MOBILE_SLIDE = 3;

  for (let i = 0; i < reviews?.length; i += REVIEWS_PER_MOBILE_SLIDE) {
    const chunk = reviews.slice(i, i + REVIEWS_PER_MOBILE_SLIDE);
    mobileReviews.push(chunk);
  }

  return (
    <div className={cn(className)}>
      <SliceConfig config={sliceConfig}>
        <SwiperCarousel
          slidesPerView={slidesPerView}
          navigation
          className={styles.carousel}
          noXPadding
          spaceBetweeen={40}
          heading={heading}
        >
          {isBreakpoint
            ? reviews?.map((review, i) => <Review {...review} key={i} />)
            : mobileReviews.map((group, i) => (
                <div key={i}>
                  {group.map((review, indx) => (
                    <div className={styles.mobileReview} key={indx}>
                      <Review {...review} />
                    </div>
                  ))}
                </div>
              ))}
        </SwiperCarousel>
      </SliceConfig>
    </div>
  );
};

export default Reviews;
